import { DEFAULT_HEADER_DATA } from './constants';
import {
  deleteApproval,
  fetchCashInBankAccounts,
  fetchGlCalendar,
  fetchPDFGenerationBase64,
  fetchPrintAuthorizedVendors,
  fetchPrintChecksCIBAccounts,
  fetchPrinterList,
  fetchPrintersWithCheckNo,
  fetchReconciliationReport,
  fetchVendors,
  postPaymentApproval,
  postArchiveData,
  postAuthorizedPayment,
  glPostingValidation,
  postPrintData,
  printChecks,
  printInterCompanyChecks,
  updatePaymentIsAuthorized,
  updateInvoiceDescriptions,
  updateInvoiceLockStatus,
  updateReconciliationPaymentStatus,
  voidAndReprintChecks,
  voidChecks,
  voidReconciliationPayment,
  fetchCashInBankInterCompany,
  fetchHighVolumeVendors,
  fetchHighVolumePrintAuthorizedVendors,
  updateInvoiceState
} from './services';
import { Client as IClient } from './types';

export const Client: IClient = {
  data: {
    deleteApproval,
    fetchCashInBankAccounts,
    fetchCashInBankInterCompany,
    fetchGlCalendar,
    fetchPDFGenerationBase64,
    fetchPrintAuthorizedVendors,
    fetchPrintChecksCIBAccounts,
    fetchPrinterList,
    fetchPrintersWithCheckNo,
    fetchReconciliationReport,
    fetchVendors,
    postPaymentApproval,
    postArchiveData,
    postAuthorizedPayment,
    glPostingValidation,
    postPrintData,
    printChecks,
    printInterCompanyChecks,
    updatePaymentIsAuthorized,
    updateInvoiceDescriptions,
    updateInvoiceLockStatus,
    updateReconciliationPaymentStatus,
    voidAndReprintChecks,
    voidChecks,
    voidReconciliationPayment,
    fetchHighVolumeVendors,
    fetchHighVolumePrintAuthorizedVendors,
    updateInvoiceState
  },
  headers: DEFAULT_HEADER_DATA,
  locale: 'en',
  defaultLocale: 'en',
  isMFE: false
};

export const mockClient: IClient = {
  ...Client,
  headers: {
    authorization: 'Bearer token',
    'remote-user': 'username',
    'x-store-id': 'S123456789',
    'x-enterprise-id': 'E1234567',
    'x-department-name': 'A',
    'x-department-type': 'TOY-A',
    'Content-Type': 'application/json'
  },
  customClientValues: {
    departments: [
      {
        storeId: 'S123456789',
        companyId: '1',
        departmentName: 'test',
        storeStatus: 'OPEN'
      }
    ],
    newSession: true,
    roles: ['ADMIN'],
    departmentIds: [{ storeId: '123', departmentIds: '122' }],
    permissions: [],
    stores: [
      {
        storeId: 'S123456789',
        name: 'Store 1',
        defaultStore: true,
        accounts: []
      }
    ],
    defaultStore: {
      storeId: 'S123456789',
      name: 'Store 1',
      defaultStore: true,
      accounts: []
    }
  }
};

export const MFEClient = {
  ...Client,
  isMFE: true
};
